import { callBackdoor } from '@/service/setting/backdoor';
import { getMe } from '@/service/setting/getMe';

/**
 * 設定
 * @param {*} $scope
 * @param {*} $cookies
 */
function settingCtrl($scope, $cookies) {
  $scope.getShiftV2UrlCookie = function () {
    //   開発環境の場合、backdoor APIを叩く必要がある
    if (process.env.NODE_ENV === 'local') {
      var origTarget = $cookies.get('CODMONSHIFTSESSID');
      if (origTarget) {
        $cookies.remove('CODMONSHIFTSESSID');
      }
      getMe().then(function (meResponse) {
        const payload = {
          userId: meResponse.id,
          facilityId: meResponse.service_id,
          role: meResponse.authorities.shift_v2,
        };
        callBackdoor(payload);
      });
    }
  };
  $scope.init = function () {
    $scope.getShiftV2UrlCookie();
  };
  $scope.init();
}

angular.module('inspinia').controller('settingCtrl', settingCtrl);
